<template>

    <div v-if="ifModel">

        <modal :showModal="showModal" :hideModal="closeModal">

            <h5 slot="header">Soumission PV</h5>

            <div slot="body" class="w-100">

                <div class="row">
                    <div class="col-8"><b>Statut PV :</b></div>
                    <div class="col-4">{{ ifModel.exported }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Date dernière tentative export :</b></div>
                    <div class="col-4">{{ ifModel.exportDatetime }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Code de retour dernière tentative export :</b></div>
                    <div class="col-4">{{ ifModel.exportResult }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Label associé au code de retour :</b></div>
                    <div class="col-4">{{ ifModel.exportResultLabel }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Message de retour dernière tentative export :</b></div>
                    <div class="col-4">{{ ifModel.exportResultMessage }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Statut image :</b></div>
                    <div class="col-4">{{ ifModel.exportedImage }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Date dernière tentative export image :</b></div>
                    <div class="col-4">{{ ifModel.exportImageDatetime }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-8"><b>Code de retour dernière tentative export image :</b></div>
                    <div class="col-4">{{ ifModel.exportImageResult }}</div>
                </div>

            </div>

            <div slot="footer">
                <button class="btn btn-danger" @click="resetExportStatus">Réinitialiser</button>
                <button class="btn btn-secondary" @click="disableExport">Ignorer</button>
                <button class="btn btn-custom" @click="exportToTigre(ifModel.id)" :disabled="exportInProgress">Soumettre <vue-element-loading :active="exportInProgress" color="#007bff" spinner="spinner"/></button>
            </div>

        </modal>

        <if-export-result-modal
                v-if="showExportResultModal"
                :showModal="showExportResultModal"
                :closeModal="closeExportResultModal"
                :exportResult="exportResult"
                :ifExportsInError="ifExportsInError"
        ></if-export-result-modal>

    </div>

</template>

<script>

    import axios from "axios";
    import Modal from './Modal';
    import IfExportResultModal from "./IfExportResultModal";
    import VueElementLoading from "vue-element-loading";

    export default {
        name: 'ifExportModal',
        components: {VueElementLoading, Modal, IfExportResultModal},
        props: {
            showModal: Boolean,
            closeModal: Function,
            ifId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                ifModel: null,
                exportInProgress: false,
                showExportResultModal: false,
                customerExportErrorLabelsByCode: [],
                exportResult: '',
                ifExportsInError: []
            }
        },
        created() {
            this.getCustomerExportErrorLabelsByCode();
            this.getIf(this.ifId);
        },
        methods: {
            getCustomerExportErrorLabelsByCode() {
                axios.get('/api/parameters/value?key=web.infringementExporter.errorLabel').then(result => {this.customerExportErrorLabelsByCode = JSON.parse(result.data);});
            },

            getIf(ifId) {
                axios.get('/api/ifs/' + ifId)
                    .then(result => {
                        this.ifModel = result.data;
                        this.ifModel = Object.assign({}, this.ifModel, {
                            exported: this.getExportStatus(result.data.exported),
                            exportDatetime: this.formatDate(result.data.exportDatetime),
                            exportResult: result.data.exportResult === 0 ? '-' : result.data.exportResult,
                            exportResultLabel: this.customerExportErrorLabelsByCode[result.data.exportResult],
                            exportedImage: this.getExportStatus(result.data.exportedImage),
                            exportImageDatetime: this.formatDate(result.data.exportImageDatetime),
                            exportImageResult: result.data.exportImageResult === 1 ? '-' : result.data.exportImageResult
                        });
                    });
            },

            getExportStatus(exportedValue) {
                if (exportedValue === null) {
                    return 'Non soumis';
                } else if (exportedValue === 0) {
                    return 'En erreur';
                } else if (exportedValue === 1) {
                    return 'Soumis';
                } else if (exportedValue === -1) {
                    return 'Ignoré';
                }
            },

            formatDate(date) {
                let formattedDate = null;
                if (date != null) {
                    const [ymd, hms] = date.split(' ');
                    const [year, month, day] = ymd.split("-");
                    formattedDate = day + '-' + month + '-' + year + ' ' + hms;
                }
                return formattedDate;
            },

            resetExportStatus() {
                axios.put('/api/ifs/reset_export_statuses/' + this.ifModel.id)
                    .then(result => {
                        this.ifModel = Object.assign({}, this.ifModel, {
                            exported: this.getExportStatus(result.data.exported),
                            exportDatetime: result.data.export_datetime,
                            exportResult: result.data.export_result,
                            exportedImage: this.getExportStatus(result.data.exported_image),
                            exportImageDatetime: result.data.export_image_datetime,
                            exportImageResult: result.data.export_image_result
                        });
                        // this.$refs.vuetable.refresh()
                    });
            },

            disableExport() {
                axios.put('/api/ifs/disable_export/' + this.ifModel.id)
                    .then(result => {
                        this.ifModel = Object.assign({}, this.ifModel, {
                            exported: this.getExportStatus(result.data.exported),
                            exportedImage: this.getExportStatus(result.data.exported_image)
                        });
                        // this.$refs.vuetable.refresh()
                    });
            },

            exportToTigre(ifId) {
                let ifIds = [];
                ifIds.push(ifId);
                this.exportInProgress = true;
                axios.post('/api/export/ifs', {ids: ifIds})
                    .then(result => {
                        this.getIf(ifId);
                        this.exportInProgress = false;
                        // this.$refs.vuetable.refresh();
                    })
                    .catch((error) => {
                        this.exportResult = 'Une erreur est survenue'
                        this.ifExportsInError = [];
                        this.exportInProgress = false;
                        this.showExportResultModal = true;
                    });
            },

            closeExportResultModal() {
                this.showExportResultModal = false;
            },
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/layout/IfExportModal.vue